#import "../../../../../common/components/DocumentPackageEmail/EmailDocumentFields.graphql"
#import "../../../../../common/components/DocumentPackageEmail/EntityEmailDocumentsFields.graphql"

mutation PaymentEmailCreate($input: PaymentEmailCreateInput!) {
  paymentEmailCreate(input: $input) {
    purchaseOrderEmail {
      __typename
      id
      _emailDocument {
        ...EmailDocumentFields
      }
      emailDocumentsByEntityId(orderBy: _CREATED_DATE_DESC) {
        nodes {
          ...EntityEmailDocumentsFields
        }
      }
    }
  }
}
